let config = {
    minQueryLength: 2,
    preventSuggestTimeout: 200,
    ignoredKeys: [13, 16, 17, 18, 27, 37, 38, 39, 40] //Arrow keys + enter + esc + shift + alt + ctrl
};

let autocompleteTargetLabel = 'autocomplete-target';

export default class Autocomplete {
    constructor(element, options) {
        config = $.extend(config, options);
        this.$element = $(element);
        this.url = this.$element.data('autocomplete');
    }

    suggest(event) {
        if (event && event.keyCode && config.ignoredKeys.indexOf(event.keyCode) !== -1) {
            return;
        }

        if (config.preventSuggestTimeout === 0) {
            return this.fetch();
        }

        clearTimeout(this.preventedSuggestTimeout);

        this.preventedSuggestTimeout = setTimeout(() => {
            this.fetch();
        }, config.preventSuggestTimeout);
    }

    fetch() {
        let self = this;
        let value = this.$element.val();
        let autocompleteTarget = $(this.$element.data(autocompleteTargetLabel));

        if (value.length < config.minQueryLength) {
            this.$element.trigger('autocomplete:clear');
            this.$element.trigger('autocomplete:hide');
            autocompleteTarget.val('');

            if(value.length === 0) {
                autocompleteTarget.trigger('change'); // this is to trigger the ads count calculation in the search form button
            }

            return;
        }

        let url = this.url.replace('{param}', this.$element.val());

        $.ajax(url, {
            headers: {
                Accept: 'text/html'
            },
            success(response) {
                self.$element.trigger('autocomplete:remove');
                self.$element.trigger('autocomplete:done', response);
            }
        });
    }

    init() {
        this.$element
            .off('keyup.autocomplete', '', $.proxy(this, 'suggest'))
            .on('keyup.autocomplete', $.proxy(this, 'suggest'));
    }
}
